import CircularProgress from '@material-ui/core/CircularProgress';
import Button from 'components/Button/Button';
import TextField from 'components/TextField/TextField';
import countries from 'data/countries';
import * as React from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import withBecomePartnerFormState, { WithBecomePartnerFormProps } from './withBecomePartnerFormState';

type Props = WithBecomePartnerFormProps;

export const BecomeParterForm: React.SFC<Props> = props => {
  const getError = (message: string | undefined) => {
    const theMessage = message || '';
    if (!theMessage) {
      return '';
    }
    if (theMessage.indexOf('required') > -1) {
      return 'This field is required';
    }
    if (theMessage.indexOf('email') > -1) {
      return 'Please enter a valid email';
    }
    return 'Invalid';
  };

  const handleCountryChange = (e: { label: string; value: string }) =>
    props.handleChange('country')(e.label);

  return (
    <form onSubmit={props.handleSubmit}>
      <NameFields>
        <LeftField
          label={'First name'}
          name="firstname"
          value={props.values.firstname}
          onChange={props.handleChange}
          errorMessage={getError(props.errors.firstname)}
        />
        <RightField
          label={'Last name'}
          name="lastname"
          value={props.values.lastname}
          errorMessage={getError(props.errors.lastname)}
          onChange={props.handleChange}
        />
      </NameFields>
      <TextField
        label={'Email'}
        type="email"
        name="email"
        value={props.values.email}
        errorMessage={getError(props.errors.email)}
        onChange={props.handleChange}
      />
      <TextField
        label={'City'}
        name="city"
        value={props.values.city}
        errorMessage={getError(props.errors.city)}
        onChange={props.handleChange}
      />

      <StyledSelect
        options={countries.map(country => ({
          label: country,
          value: country
        }))}
        placeholder="Select your country"
        // name="search"
        onChange={handleCountryChange}
        // value={props.events.eventsSearchText}
        // type="search"
        // nomargin={true}
      />

      {props.isSubmitting ? <CircularProgress /> : <Button>Send</Button>}

      <input type="submit" style={{ position: 'absolute', left: -9999 }} />
    </form>
  );
};

const NameFields = styled.div`
  display: flex;
  & > * {
    flex: 1;
  }
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const LeftField = styled(TextField)`
  padding-right: 30px;
  @media (max-width: 900px) {
    padding-right: 0;
  }
`;

const RightField = styled(TextField)`
  padding-left: 30px;
  @media (max-width: 900px) {
    padding-left: 0;
  }
`;

const StyledSelect = styled(Select)`
  width: 250px;
  color: black;
  margin-bottom: 20px;
`;
export default withBecomePartnerFormState(BecomeParterForm);



// WEBPACK FOOTER //
// ./src/components/BecomePartnerForm/BecomePartnerForm.tsx